import { render } from "./Contents.vue?vue&type=template&id=b399ef44&scoped=true"
import script from "./Contents.vue?vue&type=script&lang=js"
export * from "./Contents.vue?vue&type=script&lang=js"

import "./Contents.vue?vue&type=style&index=0&id=b399ef44&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b399ef44"]])

export default __exports__